import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Dialog, InputText, Toast } from "primereact";
import { InputNumber } from "primereact/inputnumber";

import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { useForm } from "../../../Base/Hooks/useForm";
import Loader from "../../../Base/Components/Loader/Loader";
import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../Base/Services/ToastService";

import { getEstadosCategory } from "../../../API/Global/Status/StatusRequests";
import { EditarAccounType, getClases, GuardarAccounType } from "../../../API/Finanzas/RegistroContable/RegistroContableRequest";

const AccountTypeCRUD = ({
    showDialog,
    selected,
    setSelected,
    setShowDialog,
    getInfo,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [clases, setClases] = useState([]);
  const [dialogTitle, setDialogTitle] = useState('');

  const initialValues = {
    IdType: -1,
    IdStatus: selected?.IdStatus ? selected?.IdStatus : 5,
    StatusName: selected?.StatusName ? selected?.StatusName : 'Activo',
    Type: '',
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    
    const estadosTempo = await getEstadosCategory('General')
    let est = estadosTempo.filter(i=> i?.IdStatus !== 7) 

    let estadoInicial
    if(selected?.IdType){
        setDialogTitle("Editar Tipo de Cuenta")
        estadoInicial =  estadosTempo.find((e) => e.IdStatus === selected?.IdStatus);
    }else{
        setDialogTitle("Agregar Tipo de Cuenta")
        estadoInicial =  estadosTempo[0]
    }
    setEstados(est)

    const clasesTempo = await getClases()
    setClases(clasesTempo)

    setValues({
        ...selected,
        IdType: selected?.IdType > 0 ? selected?.IdType : -10,
        IdStatus: estadoInicial?.IdStatus,
        StatusName: estadoInicial,
        IdClase: selected?.IdClase ? selected?.IdClase : null,
        Clase: selected?.Clase ? selected?.Clase : '',
    })
    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setSelected(null)
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.CodigoType) {
      error.CodigoType = true;
      error.error = true;
    }
    if (!values.Type) {
        error.Type = true;
        error.error = true;
    }
    if (!values.Clase?.IdClase && !values?.IdClase) {
        error.IdClase = true;
        error.error = true;
    }
    if (!values.StatusName?.IdStatus && !values?.IdStatus) {
        error.IdStatus = true;
        error.error = true;
    }
    if (!values.Description) {
        error.Description = true;
        error.error = true;
    }
    setError(error);
    return error;
  };

  const agregarInformacion = async () => {
    const e = verificarInfo();
    if(!e?.error){

        const Datos = {
            IdType: values?.IdType ? values?.IdType : -100,
            CodigoType: values?.CodigoType,
            Type: values?.Type,
            IdClase: values?.Clase?.IdClase || values?.IdClase,
            IdStatus: values?.StatusName?.IdStatus || values?.IdStatus,
            Description: values?.Description,
            IdUserCreate: userAuth?.IdUser,
            IdUserEdit: userAuth?.IdUser,
        }

        setLoading(true)
        if(Datos?.IdType > 0){
            const respuesta = await EditarAccounType(Datos)
            if (respuesta[0].ESTADO !== -1) {
                toastShow(toast, "success", "Editado", respuesta[0].MENSAJE);
                setTimeout(() => {
                    onHide();
                    setLoading(false);
                    getInfo();
                }, 1500);
            } else {
                toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
                setLoading(false);
            }
        }else{
            const respuesta = await GuardarAccounType(Datos)
            if (respuesta[0].ESTADO !== -1) {
                toastShow(toast, "success", "Guardado", respuesta[0].MENSAJE);
                setTimeout(() => {
                    onHide();
                    setLoading(false);
                    getInfo();
                }, 1500);
            } else {
                toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
                setLoading(false);
            }
        }

    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarInformacion}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
        getValoresIniciales();
    }
  }, [showDialog]);


  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h3 className="mx-4">{dialogTitle}</h3>
            </div>
            <Toast ref={toast}/>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <InputNumber
                    name="CodigoType"
                    value={values.CodigoType}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.CodigoType ? "p-invalid" : ""}
                  />
                  <label htmlFor="CodigoType">Código</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Type"
                    value={values.Type}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Type ? "p-invalid" : ""}
                  />
                  <label htmlFor="Type">Nombre</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
                <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                    <AutoCompleteDropdown
                        name={"Clase"}
                        value={values.Clase}
                        items={clases}
                        field={"Clase"}
                        label={"Tipo Clase"}
                        handleInputChange={handleInputChange}
                        className={error.IdClase ? "p-invalid" : ""}
                    />
                    </span>
                </div>

              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"StatusName"}
                    value={values.StatusName}
                    items={estados}
                    field={"StatusName"}
                    label={"Estado"}
                    handleInputChange={handleInputChange}
                    enable={dialogTitle !== 'Agregar Tipo de Cuenta'}
                    className={error.IdStatus ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                    <InputText
                        name="Description"
                        value={values.Description}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        className={error.Description ? "p-invalid" : ""}
                    />
                    <label htmlFor="Description">Descripción</label>
                    </span>
                </div>
            </div>

          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default AccountTypeCRUD;
